import React from "react";
import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";
import { hasRoleClaim } from "../../../utils/authUser";

interface Props {
  roles: string[],
  children: JSX.Element;
}

function RequireRole({roles, children}: Props) {
  const auth = useAuth();

  let hasRole = false;
  roles.forEach(role => {
    if (hasRoleClaim(auth.user, role)) {
      hasRole = true;
    }
  })
  
  return auth?.user && hasRole ? children : <Navigate to="/access-denied" replace />;
}

export default RequireRole;